/* global axios */
import ApiClient from './ApiClient';

class ConversationFunnelsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getFunnels(conversationId) {
    return axios.get(`${this.url}/${conversationId}/funnels`);
  }

  addToFunnel(conversationId, kanbanColumnId) {
    return axios.post(`${this.url}/${conversationId}/funnels`, {
      kanban_column_id: kanbanColumnId,
    });
  }

  moveInFunnel(conversationId, funnelId, kanbanColumnId) {
    return axios.patch(`${this.url}/${conversationId}/funnels/${funnelId}`, {
      kanban_column_id: kanbanColumnId,
    });
  }

  removeFromFunnel(conversationId, funnelId) {
    return axios.delete(`${this.url}/${conversationId}/funnels/${funnelId}`);
  }
}

export default new ConversationFunnelsAPI();
